class Slide{
    constructor(element){
        this.element = element;
        this.position = 0;
        this.scroll = 0;
        this.maxLength = 0;
    }

    onResize(maxLength){
        this.maxLength = maxLength;
    }

    setPosition(position){
        this.position = position;
        this.render();
    }

    setScroll(scroll){
        this.scroll = scroll;
    }

    getDistance(position){
        return mod(this.position + this.scroll, this.maxLength) - position;
    }

    render(){
        if(Math.abs(this.getDistance(this.last)) > this.maxLength / 3){
            this.last = mod(this.position + this.scroll, this.maxLength);
            this.element.style.setProperty("--translateX", (this.last) + "px");
            return;
        }

        // Add easing tween here
        this.last = this.last ? this.last + (mod(this.position + this.scroll, this.maxLength) - this.last) * 0.04 : mod(this.position + this.scroll, this.maxLength);
        this.element.style.setProperty("--translateX", (this.last) + "px");
    }

    adjustHeight(center){
        // Adjust --opened property based on distance from center
        const dist = Math.abs(this.getDistance(center));
        // Falloff function logarithmic
        const opened = 1 - easeOutSine(dist / (this.maxLength * 0.3));
        this.element.style.setProperty("--opened", opened);
    }
}

// Helper for negative numbers modulo
function mod(n, m) {
    return ((n % m) + m) % m;
}

// Helper for easing
function easeOutSine(x) {
    return Math.sin((x * Math.PI) / 2);
}

/**
 * How it works:
 * Slides have positions from 0 to max length : (n - 1) * (width + gap)
 * That makes it so any position %(modulo) max length will be on the allowed range
 * Then the global render is translated back so that the middle slide aligns to center
 * We then use basic math to snap the closest slide to the middle on drag leave
 */

document.addEventListener("DOMContentLoaded", () => {
    const slider = document.querySelector(".About_Slider");

    if(!slider) return;

    const inner = slider.querySelector(".About_Slider_Inner");
    const slides = Array.from(slider.querySelectorAll(".About_Slide"));

    const slideObjects = slides.map(slide => new Slide(slide));

    let indexModulo = parseInt(inner.dataset.size);
    let add = Math.floor(indexModulo / 2 + 1);

    const navLines = slider.querySelectorAll(".Nav .Line");

    console.log(indexModulo);

    function getIndex(slide){
        return (slideObjects.indexOf(slide) - add + indexModulo) % indexModulo;
    }

    // Drag Params
    let isDragging = false;
    let dragStart = 0;
    let scroll = 0;
    let lastScroll = 0;

    // Set up mouse enter and leave
    slider.addEventListener("mouseenter", (e) => {
        window.dispatchEvent(new CustomEvent("mouse:change", {detail: {text: "Drag"}}));
        window.dispatchEvent(new CustomEvent("mouse:show"));
    });
    
    slider.addEventListener("mouseleave", (e) => {
        window.dispatchEvent(new CustomEvent("mouse:hide"));
    });

    // Set up dragging
    slider.addEventListener("mousedown", (e) => {
        isDragging = true;
        dragStart = e.clientX;
        lastScroll = scroll;
        console.log("click");
    });

  if(window.innerWidth>1024){
    slider.addEventListener("mousemove", (e) => {
        if(!isDragging) return;
        const distance = e.clientX - dragStart;
        scroll = lastScroll + distance;
        scrollTo(scroll);
        monitorOpen();
    });
  }
  else{
    slider.addEventListener("touchmove", (e) => {
      if (!isDragging) return;
      const distance = (e.touches[0].clientX - dragStart) * 1.8; // Adjust multiplier for mobile
      scroll = lastScroll + distance;
      scrollTo(scroll);
      monitorOpen();
  });
  }

    

    

    slider.addEventListener("mouseup", (e) => {
        isDragging = false;
        snapToClosest();
    });

    // Support for touch events
    slider.addEventListener("touchstart", (e) => {
        isDragging = true;
        dragStart = e.touches[0].clientX;
        lastScroll = scroll;
    });

    slider.addEventListener("touchmove", (e) => {
        if(!isDragging) return;
        const distance = e.touches[0].clientX - dragStart;
        scroll = lastScroll + distance * 1.5;
        scrollTo(scroll);
        monitorOpen();
    });

    slider.addEventListener("touchend", (e) => {
        isDragging = false;
        snapToClosest();
    });

    // Set up snapping
    function snapToClosest(){
        const closestSnapSlide = slideObjects.reduce((a, b) => Math.abs(a.getDistance(centerOffset, maxLength)) < Math.abs(b.getDistance(centerOffset, maxLength)) ? a : b);
        const closestSnapScroll = closestSnapSlide.getDistance(centerOffset, maxLength);
        scrollBy(-closestSnapScroll);
    }

    function scrollBy(delta){
        slideObjects.forEach(slide => {
            const position = slide.position + delta;
            slide.setPosition(position);
        });
    }

    function scrollTo(scroll){
        slideObjects.forEach(slide => {
            slide.setScroll(scroll);
        });
    }

    // Resize Params
    let slideOffsetWidth,
    maxLength,
    centerOffset,
    globalSlidePositionOffset;

    function onResize(e){
        // Get property --gap value from slider
        const gap = parseInt(window.getComputedStyle(slider).gap) || 164;
        // Get slide width
        const slideWidth = slides[0].getBoundingClientRect().width;

        // Get highest slide height
        const slideHeight = Math.max(...slides.map(slide => slide.getBoundingClientRect().height));

        // Set up params
        slideOffsetWidth = slideWidth + gap;
        maxLength = (slides.length) * slideOffsetWidth;
        centerOffset = Math.ceil(slides.length / 3) * slideOffsetWidth;
        globalSlidePositionOffset = -(Math.ceil(slides.length / 3) * slideOffsetWidth) - (slideWidth / 2) + (window.innerWidth / 2);
        
        // Set up property --TranslateX on Inner
        inner.style.setProperty("--translateX", globalSlidePositionOffset + "px");

        // Set up slides
        slideObjects.forEach((slide, index) => {
            slide.onResize(maxLength);
            slide.setPosition(index * slideOffsetWidth, maxLength);
        });

        // Set up slider height
        inner.style.height = slideHeight + "px";
    }
    onResize();
    window.addEventListener("resize", (e)=>{
        if(window.innerWidth < 1024) return;
        onResize(e);
    });

    function monitorOpen(){
        slideObjects.forEach(slide => {
            slide.element.classList.remove("Open");
        });
        const closestSlide = slideObjects.reduce((a, b) => Math.abs(a.getDistance(centerOffset, maxLength)) < Math.abs(b.getDistance(centerOffset, maxLength)) ? a : b);
        closestSlide.element.classList.add("Open");

        console.log(getIndex(closestSlide));

        navLines.forEach((line) => {
            line.classList.remove("Open");
        });
        navLines[getIndex(closestSlide)].classList.add("Open");
    }
    monitorOpen();

    slideObjects.forEach((slide, index) => {
        slide.setPosition(index * slideOffsetWidth, maxLength);
    });

    function animate(){
        slideObjects.forEach(slide => {
            slide.render(maxLength);
            slide.adjustHeight(centerOffset, slideOffsetWidth / 8);
        });
        requestAnimationFrame(animate);
    }
    requestAnimationFrame(animate);
});
  